import type { ApiClient } from "./client";
import type { AuditLog, CreateTenantRequest, LoginResponse, Page, Plan, PlanInput, StaffUser, SubscriptionUpdate, TenantInsights, TenantSummary, User } from "./types";

/** The Superadmin console's slice of §17.1: /tenants, /admin/plans, /admin/audit-logs. */
export function endpoints(c: ApiClient) {
  return {
    auth: {
      login: (username: string, password: string) => c.post<LoginResponse>("/auth/login", { username, password }),
      me: () => c.get<User>("/auth/me"),
    },
    tenants: {
      list: () => c.get<TenantSummary[]>("/tenants"),
      create: (b: CreateTenantRequest) => c.post<TenantSummary>("/tenants", b),
      approve: (id: number) => c.post<TenantSummary>(`/tenants/${id}/approve`),
      reject: (id: number) => c.post<TenantSummary>(`/tenants/${id}/reject`),
      activate: (id: number) => c.post<TenantSummary>(`/tenants/${id}/activate`),
      deactivate: (id: number) => c.post<TenantSummary>(`/tenants/${id}/deactivate`),
      remove: (id: number) => c.del<void>(`/tenants/${id}`),
      subscription: (id: number, b: SubscriptionUpdate) => c.put<TenantSummary>(`/tenants/${id}/subscription`, b),
      insights: (id: number) => c.get<TenantInsights>(`/tenants/${id}/insights`),
      users: (id: number) => c.get<StaffUser[]>(`/tenants/${id}/users`),
      impersonate: (id: number, userId: number) => c.post<LoginResponse>(`/tenants/${id}/users/${userId}/impersonate`),
    },
    plans: {
      list: () => c.get<Plan[]>("/admin/plans"),
      create: (b: PlanInput) => c.post<Plan>("/admin/plans", b),
      update: (id: number, b: PlanInput) => c.put<Plan>(`/admin/plans/${id}`, b),
      archive: (id: number, archived: boolean) => c.put<Plan>(`/admin/plans/${id}/archive`, { archived }),
    },
    audit: {
      list: (q: { page?: number; size?: number; tenantId?: number }) => c.get<Page<AuditLog>>("/admin/audit-logs", { query: q }),
    },
  };
}
export type Endpoints = ReturnType<typeof endpoints>;
